/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, ViewChild, ElementRef, ViewChildren, TemplateRef, OnDestroy, EventEmitter } from '@angular/core';
import { LookupDataService } from '../services/lookup-data.service';
import { IColumnModel, ColumnModel, IRowModel, RowModel } from 'table-editor';
import { Army } from '../models/army';
import { PrimaryWeapon } from '../models/primaryWeapon';
import { SecondaryWeapon } from '../models/secondaryWeapon';
import { LUArmy } from '../models/luArmy';
import { ImageType } from '../models/imageType';
import { Regiment } from '../models/regiment';
import { BatchLog } from '../models/batchLog';
import { Weapon } from '../models/weapon';
import { Rank } from '../models/rank';
import { State } from '../models/state';
import { RankCategory } from '../models/rankCategory';
import { LU_QM_SourceReference } from '../models/luqmsourcereferencemodel';
import { LU_QM_SpecificationCategory} from '../models/luqmspecificationcategory';
import { BranchOfService } from '../models/branchOfService';
import { debounceTime, distinctUntilChanged, switchMap, map, catchError, finalize } from 'rxjs/operators';
import { of, Observable, Subscription, forkJoin } from 'rxjs';
import { TypeaheadResults } from '../models/typeaheadResults';
import { IEditCheck, toggleObjInArray, AlphaSortArrayByProperty, FilterParams, StarbaseEntity } from 'starbase-launcher';
import { StarbaseModalOptions, StarbaseModalButton, StarbaseModalDialogService, StarbaseModalTypes } from 'starbase-modal-dialog';
import { StarbaseNotificationService, StarbaseNotificationTypes, StarbaseNotificationSentiment } from 'starbase-notification';
import { LUSource } from '../models/luSource';
import { RelatedSetLinkingModel } from '../models/relatedSetLinkingModel';
import { BoundImageSet } from '../models/boundImageSet';
import { CallNumberModel } from '../models/callNumberModel';
import { StarbaseLoginService } from 'starbase-login';
import { LuSubscriptionPriceService } from '../services/lu-subscriptionprice.service';
import { LuSubscriptionDiscountService } from '../services/lu-subscriptiondiscount.service';
import { ITableColumn, NewTableEditorUserViewOptions, NewTableEditorComponent, TypeaheadTableColumn, TableColumn } from 'new-table-editor';
import { LU_SubscriptionPriceModel_ext } from '../models/lu_subscriptionprice';
import { LU_SubscriptionDiscountModel } from '../models/lu_subscriptiondiscount';
import { StarbaseComponentMessageService } from '../services/starbase-component-message.service';
import { LU_ContactType_ext } from '../models/lu_contacttype';
import { LuContactTypeService } from '../services/lu-contacttype.service';
import { Battle } from '../models/battle';
import { LU_Keyword } from '../models/keyword';
import { KeywordDataService  } from '../services/keyword-data.service';
import { KeywordBadgeComponent } from '../keyword-badge/keyword-badge.component';
import { GalleryTypeService } from '../services/gallery-type.service';
import { ImageFile } from '../models/imageFile';
import { Router } from '@angular/router';
import { BattleDataService } from '../services/battle-data.service';
import { BoundSetService } from '../services/bound-set.service';
import { RelatedSetService } from '../services/related-set.service';
import { SourceService } from '../services/source.service';
import { CallNoService } from '../services/call-no.service';
import { BreakpointService } from '../breakpoint.service';
import { RelatedSetModel } from '../models/relatedSetModel';

@Component({
  selector: 'app-lookup-table-wrapper',
  templateUrl: './lookup-table-wrapper.component.html',
  styleUrls: ['./lookup-table-wrapper.component.css']
})

export class LookupTableWrapperComponent implements OnInit, IEditCheck, OnDestroy {
  @ViewChild('inFocus') focus: ElementRef;
  @ViewChild('luOptionsModal', { static: true }) luOptionsModal: TemplateRef<any>;
  @ViewChildren('tableEditor') tableEditor;
  @ViewChild('relatedImageSet') imageSetTable;
  @ViewChild('deleteConfirmModal', { static: true }) deleteConfirmModal: TemplateRef<any>;
  @ViewChild('deleteUploadLogConfirmationModal', { static: true }) deleteUploadLogsModal: TemplateRef<any>;
  @ViewChild('deleteMultipleUploadLogConfirmationModal', { static: true }) deleteMultipleUploadLogsModal: TemplateRef<any>;
  @ViewChild('deletionConfirmationText') deletionConfirmationText: ElementRef;
  @ViewChild('subscriptionTable') subscriptionTable: NewTableEditorComponent<LU_SubscriptionPriceModel_ext>;
  @ViewChild('mergeKeywordsPrompt', { static: true }) mergeKeywordsPrompt: TemplateRef<any>;

  paginationOn = true;
  rpp = 5;
  page = 2;
  tableData;
  isAdmin = false;
  tableWidth = '100';
  newEntityMode = false;
  newEntityColumnData = [];
  newEntityRows = [];
  newEntityModeTitle = '';
  armyRows: Army[] = [];
  armyCols: IColumnModel[] = [];
  armyData: Army[];
  armyRowsEditMode = false;
  primaryWeaponsRows: PrimaryWeapon[] = [];
  primaryWeaponsCols: IColumnModel[] = [];
  primaryWeaponsColsEditMode = false;
  secondaryWeaponsRows: SecondaryWeapon[] = [];
  secondaryWeaponsCols: IColumnModel[] = [];
  secondaryWeaponsColsEditMode = false;
  statesRows: State[] = [];
  statesCols: IColumnModel[] = [];
  statesColsEditMode = false;
  imageTypeRows: ImageType[] = [];
  imageTypeCols: IColumnModel[] = [];
  imageTypeColsEditMode = false;
  unitCols: IColumnModel[] = [];
  unitColsEditMode = false;
  batchLogRows: BatchLog[] = [];
  batchLogCols: IColumnModel[] = [];
  batchLogColsEditMode = false;
  weaponsRows: Weapon[] = [];
  weaponsCols: IColumnModel[] = [];
  weaponsColsEditMode = false;
  ranksRows: Rank[] = [];
  ranksCols: IColumnModel[] = [];
  ranksColsEditMode = false;
  rankCategoriesRows: RankCategory[] = [];
  rankCategoriesCols: IColumnModel[] = [];
  rankCategoryColsEditMode = false;
  regimentCols: IColumnModel[] = [];
  regimentRows: Regiment[] = [];
  regimentColsEditMode = false;
  LUarmyRows: LUArmy[] = [];
  LUarmyCols: IColumnModel[] = [];
  LUArmyData: LUArmy[] = [];
  LUarmyColsEditMode = false;

  // Quartermaster Source Reference
  LuQmSourceReferenceRows: LU_QM_SourceReference[] = [];
  LuQmSourceReferenceCols: IColumnModel[] = [];
  LuQmSourceReferenceData: LU_QM_SourceReference[] = [];
  LuQmSourceReferenceColsEditMode = false;

  // Quartermaster Specification Category
  LU_QM_SpecificationCategoryRows: LU_QM_SpecificationCategory[] = [];
  LU_QM_SpecificationCategoryCols: IColumnModel[] = [];
  LU_QM_SpecificationCategoryData: LU_QM_SpecificationCategory[] = [];
  LU_QM_SpecificationCategoryColsEditMode = false;

  /* Global "New" Table Editor options */
  showRecordUIDs = false;
  showRecordGUIDs = false;
  showRecordWhodunits = false;

  branchRows: BranchOfService[] = [];
  branchCols: IColumnModel[] = [];
  boundImageSetRows: BoundImageSet[] = [];
  boundImageSetCols: IColumnModel[] = [];
  boundImageSetColsEditMode = false;
  currentBoundSetName: string;
  branchColsEditMode = false;
  DEFAULT_DEBOUNCE = 300;
  armies: Army[] = [];
  weapons: Weapon[] = [];
  stateData: State[] = [];
  newEntityModeType = '';
  activeTables = [];
  newEntityBackup: any;
  /* eslint-disable @typescript-eslint/no-use-before-define */
  notifier = new Notifier();
  boundImageSetNotifier = new Notifier();
  entireBoundImageSetsNotifier = new Notifier();
  filterNotifier = new Notifier();
  weaponsRowsNotifier = new Notifier();
  armyRowsNotifier = new Notifier();
  relatedImageSetNotifier = new Notifier();
  primaryWeaponsRowsNotifier = new Notifier();
  rankCategoriesRowsNotifier = new Notifier();
  statesRowsNotifier = new Notifier();
  imageTypeRowsNotifier = new Notifier();
  batchLogRowsNotifier = new Notifier();
  ranksRowsNotifier = new Notifier();
  LUarmyRowsNotifier = new Notifier();
  LuQmSourceReferenceRowsNotifier = new Notifier();
  LU_QM_SpecificationCategoryRowsNotifier = new Notifier();
  branchRowsNotifier = new Notifier();
  regimentRowsNotifier = new Notifier();
  sourceDataNotifier = new Notifier();
  sourceCols: IColumnModel[] = [];
  sourceData: LUSource[] = [];
  sourceColsEditMode = false;
  LUArmyFocus = false;
  rankCategories;
  adjustRpp = true;
  tableMaxHeight = '135px';
  rppOptions = [5, 10, 25, 50, 100];
  isLoading = false;
  relatedImageSetCols: IColumnModel[] = [];
  relatedImageSetRows: RelatedSetModel[] = [];
  relatedImageSetData = [];
  currentRelatedSetName: string;
  boundImageCarouselArray = [];
  boundSets = [];
  deleteBoundImageSetSubscriber: Subscription;
  deleteModal: StarbaseModalOptions;
  callNumberCols: IColumnModel[];
  callNumberData: CallNumberModel[] = [];
  callNumberDataNotifier = new Notifier();
  callNumberColsEditMode: boolean;


  /** "New" Starbase Lookup Tables info */
  public lookupTables: {
    name: string;
    columnDefs: ITableColumn[];
    tableViewOpts: NewTableEditorUserViewOptions;
    active: boolean;
  }[] = [];

  mergeKeywordsMode = false;
  keywordsMergeList: LU_Keyword[] = [];
  reviewSelectedKeywords = true;

  dataLoadSubscription: Subscription;
  l1SelectCallNumberEmitter: EventEmitter<{ index: number, value: string, rowData: any }>;
  l2SelectCallNumberEmitter: EventEmitter<{ index: number, value: string, rowData: any }>;
  l3SelectCallNumberEmitter: EventEmitter<{ index: number, value: string, rowData: any }>;
  l4SelectCallNumberEmitter: EventEmitter<{ index: number, value: string, rowData: any }>;
  callNumberFirstDescriptionsForLevel: [Map<string, string>, Map<string, string>, Map<string, string>, Map<string, string>] = [new Map<string, string>(), new Map<string, string>(), new Map<string, string>(), new Map<string, string>()] // holds the first callnumberDescriptionValue for a given level

  constructor(
    private lookupSvc: LookupDataService,
    private modalSvc: StarbaseModalDialogService,
    private notificationSvc: StarbaseNotificationService,
    private loginSvc: StarbaseLoginService,
    private galleryTypeSvc: GalleryTypeService,
    private router: Router,
    protected battleSvc: BattleDataService,
    public keywordsSvc: KeywordDataService,
    protected subscriptionSvc: LuSubscriptionPriceService,
    protected discountSvc: LuSubscriptionDiscountService,
    protected contactTypeSvc: LuContactTypeService,
    protected boundSetSvc: BoundSetService,
    protected relatedSetSvc: RelatedSetService,
    protected sourceSvc: SourceService,
    protected callNoSvc: CallNoService,
    protected sbCmpMsgSvc: StarbaseComponentMessageService,
    private breakpointSvc: BreakpointService) { }

  ngOnInit() {
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<State>(this.lookupSvc.getStatesUrl)
      .subscribe(states => this.stateData = states);
    this.isAdmin = this.loginSvc.getUserModel().isAdmin();

    this.lookupTables = [
      {
        name: 'Subscriptions',
        columnDefs: [],
        tableViewOpts: new NewTableEditorUserViewOptions(true, false, false, false, false),
        active: false
      },
      {
        name: 'ContactTypes',
        columnDefs: LU_ContactType_ext.ContactTypesColumns(this.showRecordUIDs, this.showRecordGUIDs, this.showRecordWhodunits),
        tableViewOpts: new NewTableEditorUserViewOptions(true, false, false, false, false),
        active: false
      },
      {
        name: 'Discounts',
        columnDefs: [],
        tableViewOpts: new NewTableEditorUserViewOptions(true, false, false, false, false),
        active: false
      },
      {
        name: 'Keywords',
        columnDefs: LU_Keyword.KeywordColumns(this.showRecordUIDs, this.showRecordGUIDs, this.showRecordWhodunits),
        tableViewOpts: new NewTableEditorUserViewOptions(true, true),
        active: false
      },
      {
        name: 'Battles',
        columnDefs: Battle.BattleColumns(this.showRecordUIDs, this.showRecordGUIDs, this.showRecordWhodunits),
        tableViewOpts: new NewTableEditorUserViewOptions(true, false, false, false, false),
        active: false
      },
      {
        name: 'BoundImageSets',
        columnDefs: BoundImageSet.boundImageSetColumns(true),
        tableViewOpts: new NewTableEditorUserViewOptions(true, false, false, false, false),
        active: false
      },
      {
        name: 'RelatedImageSets',
        columnDefs: RelatedSetModel.relatedImageSetColumns(),
        tableViewOpts: new NewTableEditorUserViewOptions(true, false, false, false, false),
        active: false
      },
      {
        name: 'Sources',
        columnDefs: LUSource.SourceColumns(true),
        tableViewOpts: new NewTableEditorUserViewOptions(true, false, false, false, false),
        active: false
      },
      {
        name: 'Call Numbers',
        columnDefs: [],
        tableViewOpts: new NewTableEditorUserViewOptions(true, false, false, false, false),
        active: false
      }
    ];

    this.lookupTables.forEach(t => t.tableViewOpts.columnHeaderTextAlignment = 'left');
    this.lookupTables[2].tableViewOpts.showColumnDividers = true;
    this.lookupTables[3].tableViewOpts.allowAutoReload = false;

    this.setupLookupTableData();

    this.sourceSvc.refreshTrigger$.subscribe(() => this.setupLookupTableData());
    this.callNoSvc.refreshTrigger$.subscribe(() => this.setupLookupTableData());

    this.lookupTables[6].columnDefs = RelatedSetModel.relatedImageSetColumns();
  }

  ngOnDestroy() {
    if (this.dataLoadSubscription) {
      this.dataLoadSubscription.unsubscribe();
    }

    if(this.l1SelectCallNumberEmitter) {
      this.l1SelectCallNumberEmitter.unsubscribe();
    }

    if(this.l2SelectCallNumberEmitter) {
      this.l2SelectCallNumberEmitter.unsubscribe();
    }

    if(this.l3SelectCallNumberEmitter) {
      this.l3SelectCallNumberEmitter.unsubscribe();
    }

    if(this.l4SelectCallNumberEmitter) {
      this.l4SelectCallNumberEmitter.unsubscribe();
    }
  }

  setupLookupTableData() {
    forkJoin([this.subscriptionSvc.getUserGroups(),
      this.subscriptionSvc.getAllData(this.subscriptionSvc.getAllUri),
      this.sourceSvc.getAllData(this.sourceSvc.getAllUri),
      this.lookupSvc.getAllRequisiteData<LUSource>(this.lookupSvc.getCallNumbersUrl+ '?includeEmptySets=true'),
      ]).subscribe(([groups, subscriptions, sources, callNumbers]) => {
        this.lookupTables[0].columnDefs = LU_SubscriptionPriceModel_ext.TableColumns(this.showRecordUIDs, this.showRecordGUIDs, this.showRecordWhodunits, groups);
        this.lookupTables[2].columnDefs = LU_SubscriptionDiscountModel.TableColumns(this.showRecordUIDs, this.showRecordGUIDs, this.showRecordWhodunits, subscriptions);

        const callLevelTypeaheadOptions = {
          l1: new Set<string>(), 
          l2: new Set<string>(), 
          l3: new Set<string>(), 
          l4: new Set<string>()
        };

        this.callNumberFirstDescriptionsForLevel = [new Map<string, string>(), new Map<string, string>(), new Map<string, string>(), new Map<string, string>()];
        for (const { callNumberL1, description, callNumberL2, descriptionL2, callNumberL3, descriptionL3, callNumberL4, descriptionL4 } of callNumbers as unknown as CallNumberModel[]) {
          if (callNumberL1) callLevelTypeaheadOptions.l1.add(callNumberL1);
          if(description && !this.callNumberFirstDescriptionsForLevel[0].has(callNumberL1)) {
            this.callNumberFirstDescriptionsForLevel[0].set(callNumberL1, description);
          }
          
          if (callNumberL2) callLevelTypeaheadOptions.l2.add(callNumberL2);
          if(descriptionL2 && !this.callNumberFirstDescriptionsForLevel[1].has(callNumberL2)) {
            this.callNumberFirstDescriptionsForLevel[1].set(callNumberL2, descriptionL2);
          }
          
          if (callNumberL3)callLevelTypeaheadOptions.l3.add(callNumberL3);
          if(descriptionL3 && !this.callNumberFirstDescriptionsForLevel[2].has(callNumberL3)) {
            this.callNumberFirstDescriptionsForLevel[2].set(callNumberL3, descriptionL3);
          }
          
          if (callNumberL4) callLevelTypeaheadOptions.l4.add(callNumberL4);
          if (descriptionL4 && !this.callNumberFirstDescriptionsForLevel[3].has(callNumberL4)) {
            this.callNumberFirstDescriptionsForLevel[3].set(callNumberL4, descriptionL4);
          }
        }

        this.lookupTables[8].columnDefs = CallNumberModel.callNoColumns(sources, {
          l1: [...callLevelTypeaheadOptions.l1],
          l2: [...callLevelTypeaheadOptions.l2],
          l3: [...callLevelTypeaheadOptions.l3],
          l4: [...callLevelTypeaheadOptions.l4]
        }, this.isAdmin);

        // Unregister old emitters and register new ones
        for (let i = 0; i < this.lookupTables[8].columnDefs.length; i++) {
          if ([1, 3, 5, 7].includes(i)) {
            this[`l${i}SelectCallNumberEmitter`]?.unsubscribe();
            const emitter = (this.lookupTables[8].columnDefs[i] as TypeaheadTableColumn).selectOptionEmitter;
            emitter.subscribe((e) => this.onCallNumbersTypeaheadSelect(e));
            this[`l${i}SelectCallNumberEmitter`] = emitter;
          }
        }
      }
    );
  }

  onCallNumbersTypeaheadSelect(ev: { index: number, value: string, rowData: any }) {
    // if user selects a col number and the description for that levek is not set, set it to the first description for the matching level
    const descCol = this.lookupTables[8].columnDefs[ev.index + 1] as TableColumn;
    const typeaheadCol = this.lookupTables[8].columnDefs[ev.index] as TypeaheadTableColumn;

    console.log ({ descCol, rowData: ev.rowData, ev });
    if (!descCol || ev.rowData.uid !== 0 || ev.rowData[descCol.columnName]) return;
    
    const mapIndex = parseInt(typeaheadCol.columnName.split("callNumberL")[1]) - 1;
    if (Number.isNaN(mapIndex) || mapIndex < 0 || mapIndex > 3) return;
    //ev.rowData[descCol.columnName] = this.callNumberFirstDescriptionsForLevel[mapIndex].get(ev.value);
  }

  lookupTable(name: string): ({
    name: string;
    columnDefs: ITableColumn[];
    tableViewOpts: NewTableEditorUserViewOptions;
    active: boolean;
  }) {
    return this.lookupTables.find(t => t.name === name);
  }

  getCallNumbers() {
    this.isLoading = true;
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<LUSource>(this.lookupSvc.getLUSourcesUrl).subscribe(l => {
      this.sourceData = l;
      this.callNumberCols = CallNumberModel.CallNumberColumnsData(this.sourceData, this.isAdmin);
      this.lookupSvc.getCallNumbersFromServer(true)
        .subscribe(d => {
          CallNumberModel.setupCallNumberCollection(d);
          this.callNumberData = d;
        });
      this.callNumberColsEditMode = true;
      this.focusOnTable('callNoCols');
      this.isLoading = false;
    });
  }

  viewLinkedBattleRecords(battle: Battle): void {
    if (battle.uid && battle.appears > 0) {
      this.battleSvc.getAllData().subscribe(
        (battles) => {
          battles.forEach(b => b.selected = battle.uid === b.uid);
          this.galleryTypeSvc.clearCurrentFilterOptions();
          this.galleryTypeSvc.storeKeywordFilter('');
          this.galleryTypeSvc.setCurrentLibraryFilters(new FilterParams<ImageFile>());
          this.galleryTypeSvc.setPrePrintedMode(false);
          this.galleryTypeSvc.CivilianResearchMode = false;
          this.galleryTypeSvc.setGalleryType(new ImageType(''));
          this.galleryTypeSvc.setCurrentFilterOptions('Battles', battles);
          const currentFilters = this.galleryTypeSvc.getCurrentLibraryFilters();
          currentFilters.replaceFilter('BattleLinks.BattleUID', +battle.uid);
          this.galleryTypeSvc.setCurrentLibraryFilters(currentFilters);
          this.galleryTypeSvc.clearLibraryImages();
          this.router.navigate(['/library/']);
        }
      );
    } else {
      this.notificationSvc.postNotification(
        this.notificationSvc.notificationBuilder(
          'Warning',
          'Battle does not appear on any Image records.',
          null,
          null,
          StarbaseNotificationSentiment.Warning
        )
      );
    }
  }

  viewCallNoRecords(callNo: CallNumberModel): void {
    if (callNo.uid && callNo.imagesExist) {
      this.galleryTypeSvc.clearCurrentFilterOptions();
      this.galleryTypeSvc.storeKeywordFilter('');
      this.galleryTypeSvc.setCurrentLibraryFilters(new FilterParams<ImageFile>());
      this.galleryTypeSvc.setPrePrintedMode(false);
      this.galleryTypeSvc.CivilianResearchMode = false;
      this.galleryTypeSvc.setGalleryType(new ImageType(''));
      this.galleryTypeSvc.setCurrentFilterOptions('SourceCallNo', [callNo]);
      const currentFilters = this.galleryTypeSvc.getCurrentLibraryFilters();
      currentFilters.replaceFilter('SourceCallNumberId', callNo.uid);
      this.galleryTypeSvc.setCurrentLibraryFilters(currentFilters);
      this.galleryTypeSvc.clearLibraryImages();
      this.router.navigate(['/library']);
    } else {
      this.notificationSvc.postNotification(
        this.notificationSvc.notificationBuilder(
          'Warning',
          'Call Number does not appear on any Image records.',
          null,
          null,
          StarbaseNotificationSentiment.Warning
        )
      );
    }
  }

  handleBoundDoubleClick(set: BoundImageSet) {
    if (set && set.imageModelId) {
      this.router.navigate(['/imageSingleView/' + set.imageModelId]);
    }
  }

  handleRelatedDoubleClick(set: RelatedSetModel) {
    if (set.imagesInSet === 0) {
          this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder(
          'Unused Related Image Set',
          'That Related Set does not contain any records.',
          undefined, undefined, StarbaseNotificationSentiment.Warning
        ));
        return;
    }
    this.galleryTypeSvc.clearCurrentFilterOptions();
    this.galleryTypeSvc.storeKeywordFilter('');
    this.galleryTypeSvc.setCurrentLibraryFilters(new FilterParams<ImageFile>());
    this.galleryTypeSvc.setPrePrintedMode(false);
    this.galleryTypeSvc.CivilianResearchMode = false;
    this.galleryTypeSvc.setGalleryType(new ImageType(''));
    const currentFilters = this.galleryTypeSvc.getCurrentLibraryFilters();
    currentFilters.replaceFilter('RelatedSetUID', set.uid);
    currentFilters.sortFields[0] = 'SequenceNumber';
    this.galleryTypeSvc.setCurrentLibraryFilters(currentFilters);
    this.galleryTypeSvc.clearLibraryImages();
    this.router.navigate(['/library/']);
          
  }

  handleKeywordDoubleClick(keyword: LU_Keyword): void {
    if (this.mergeKeywordsMode) {
      this.pushKeywordSelection(keyword);
    } else { // otherwise start filtering 'View All' gallery by this keyword and change route.
      if (keyword.appears === 0) {
        this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder(
          'Unused Keyword',
          'That keyword does not appear on any records.',
          undefined, undefined, StarbaseNotificationSentiment.Warning
        ));
        return;
      }
      // this.galleryTypeSvc.setCurrentLibraryFilters(new FilterParams<ImageFile>());
      this.galleryTypeSvc.CivilianResearchMode = false;
      this.galleryTypeSvc.setPrePrintedMode(false); // also sets the currentLibFilters to new fp
      this.galleryTypeSvc.setGalleryType(new ImageType('')); // View All mode
      const newFilter = new KeywordBadgeComponent(this.galleryTypeSvc, this.modalSvc, this.keywordsSvc, this.breakpointSvc);
      newFilter.filterByMeEmitter.subscribe(() => this.router.navigateByUrl('/library'));
      newFilter.keyword = keyword;
      newFilter.changeFilterToMe();
    }
  }
  pushKeywordSelection(keyword: LU_Keyword): void {
    console.log(keyword.keyword + ' pushed to merge list');
    if (!this.mergeKeywordsMode) {
 return;
}
    toggleObjInArray(this.keywordsMergeList, keyword);
  }
  executeKeywordMerging(): void {
    if (this.keywordsMergeList.length < 2) {
      this.notificationSvc.postNotification(
        this.notificationSvc.notificationBuilder(
          'Invalid selection',
          'You must choose a target keyword and at least one keyword to be merged.', undefined, undefined, StarbaseNotificationSentiment.Error));
      return;
    }
    const target = this.keywordsMergeList[0];
    const toMerge = this.keywordsMergeList.slice(1);
    this.modalSvc.postModal(
      new StarbaseModalOptions(
        'Merge keywords',
        undefined,
        [
          new StarbaseModalButton('Cancel', () => this.modalSvc.closeModal('User cancelled keyword merge action')),
          new StarbaseModalButton('Merge', () => this.handleKeywordsMerge(target, toMerge))
        ],
        StarbaseModalTypes.Success,
        this.mergeKeywordsPrompt
      )
    );
  }

  handleKeywordsMerge(target: LU_Keyword, toMerge: LU_Keyword[]): void {
    this.keywordsSvc.mergeKeywords(target, toMerge, this.reviewSelectedKeywords).subscribe(
      () => this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Action completed', 'Keywords were merged', null, null, StarbaseNotificationSentiment.Success)),
      (e) => {
        console.error(e);
        this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Action failed', 'Keywords did not complete the merge process', null, null, StarbaseNotificationSentiment.Error));
      },
      () => {
        this.modalSvc.closeModal('Keywords were merged.');
        this.mergeKeywordsMode = false;
        this.keywordsSvc.triggerRefresh();
      }
    );
  }

  handleModifyBoundImageSet(e) {
    let i = 0;
    let index = null;
    this.boundImageSetRows.forEach(r => { // FIXME: Why are we doing this to find the index instead of indexOf()?
      // eslint-disable-next-line eqeqeq
      if (r == e) {
        index = i;
      } else {
        i++;
      }
      });
      this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<BoundImageSet>(this.lookupSvc.getAllBoundRecordSetsUrl).subscribe(data => {
      this.lookupSvc.renameBoundImageSet(encodeURIComponent(data[index].name), encodeURIComponent(e.name)).subscribe(() => {
        this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Success!', 'Your changes have been saved', StarbaseNotificationTypes.Success));
      }, () => {
          this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Failure', 'Your changes could not be saved', StarbaseNotificationTypes.Error));
          this.boundImageSetRows.forEach(r => {
            if (r === e) {
              setTimeout(() => {
                r['editMode'] = true;
              }, 1);
            }
          });
        });
    });
  }


  //FIXME: OUTDATED NEEDS TO BE REVIEWED FOR REMOVAL
  /* 
  handleModifyRelatedImageSet(set: RelatedSetLinkingModel) {
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<RelatedSetLinkingModel>(this.lookupSvc.getAllRecordSetsUrl).subscribe(recordSet => {
      recordSet.forEach(record => {
        if (set.sequenceNumber === record.sequenceNumber) {
          this.lookupSvc.saveModifiedRecordSetToServer(record.name, set.name).subscribe(() => {
            this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Success!', 'Your changes have been saved', StarbaseNotificationTypes.Success));
          }, () => {
              this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Failure', 'Your changes could not be saved', StarbaseNotificationTypes.Error));
            });
        }
      });
    });
  }
  */

  enableLeavePageModal(): Observable<boolean> {
    const m = new Observable<boolean>(obj => {
      const modal = new StarbaseModalOptions('Confirm Navigation', 'Are you sure you want to discard your changes?', [
        new StarbaseModalButton('Yes', () => {
          obj.next(true);
          this.modalSvc.closeModal('User left page');
        }),
        new StarbaseModalButton('No', () => {
          obj.next(false);
          this.modalSvc.closeModal('User stayed on page');
        }),
      ], 2);
      modal.dismissable = false;
      this.modalSvc.postModal(modal);
    });
    return m;
  }

  enableDeleteRowModal(msg?: string): Observable<boolean> {
    console.log(msg);
    const m = new Observable<boolean>(obj => {
      const modal = new StarbaseModalOptions('Confirm Deletion', msg ? msg : 'Are you sure you want to delete this data forever?', [
        new StarbaseModalButton('Yes', () => {
          obj.next(true);
          this.modalSvc.closeModal('User Deleted Row');
        }),
        new StarbaseModalButton('No', () => {
          obj.next(false);
          this.modalSvc.closeModal('User did not delete row');
        }),
      ], 3);
      modal.dismissable = true;
      this.modalSvc.postModal(modal);
    });
    return m;
  }

  enableRowModifiedNotification(msg?: string) {
    this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Success!', msg ? msg : 'Data Saved Successfully', StarbaseNotificationTypes.Success));
  }

  enableRowModificationFailure(msg?) {
    this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Failure', msg ? msg : 'Could Not Update', StarbaseNotificationTypes.Error));
  }

  weaponNameSearch = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(this.DEFAULT_DEBOUNCE),
      distinctUntilChanged(),
      switchMap(term =>
        this.lookupSvc.typeaheadSearch(term, ['weaponmodel']).pipe(
          map((r: TypeaheadResults) => r.matches[0].hits['weapon']),
          catchError((e) => {
            console.error('Typeahead error: ', e['friendly']);
            return of([]);
          }
        )
      )
    )
  );

  handleCancelNewRow(row: IRowModel, notifier: string) {
    this.enableDeleteRowModal().subscribe(a => {
      if (a === true) {
        this[notifier].valueChanged(row);
      }
    });
  }

  getBoundImageSetsData() {
    this.boundImageSetCols = BoundImageSet.boundImageSetColumnData(this.isAdmin);
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<BoundImageSet>(this.lookupSvc.getAllBoundRecordSetsUrl).subscribe(data => {
      this.boundImageSetCols = [
        new ColumnModel('Name', 'name', 'name', this.isAdmin, 'string', false, false, 150, false),
        new ColumnModel('Created By', 'createdByUser', 'createdByUser', false, 'string', false, false, 100, false),
        new ColumnModel('Created Date/Time', 'createdDateTime', 'createdDateTime', false, 'date', false, false, 100, false),
    ];
      this.boundImageSetRows = data;
      this.focusOnTable('boundImageSetCols');
      this.isLoading = false;
    });
  }

  getRelatedImageData() {
    this.isLoading = true;
    //TODO: Update to new model -> RelatedSetModel
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<RelatedSetModel>(this.lookupSvc.getAllRecordSetsUrl).subscribe((i) => {
      this.relatedImageSetCols = RelatedSetModel.relatedImageSetColumnData(this.isAdmin);
      this.relatedImageSetRows = i;
      this.focusOnTable('relatedImageSets');
      this.isLoading = false;
    });
  }

  getArmies() {
    this.isLoading = true;
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<Army>(this.lookupSvc.getArmiesUrl).subscribe((a: Army[]) => {
      Army.setupArmyCollection(a);
      this.lookupSvc.getAllRequisiteData<LUArmy>(this.lookupSvc.getLUArmiesUrl).subscribe(l => {
        this.armyCols = Army.ArmyColumnData(l, this.isAdmin);
        this.armyRows = a;
        this.armyData = a;
        this.focusOnTable('armyCols');
        this.isLoading = false;
      });
    });
  }

  getPrimaryWeapons() {
    this.isLoading = true;
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<PrimaryWeapon>(this.lookupSvc.getPrimaryWeaponsUrl).subscribe((weapons: PrimaryWeapon[]) => {
      this.primaryWeaponsCols = PrimaryWeapon.PrimaryWeaponColumnData(this.isAdmin);
      this.primaryWeaponsRows = weapons;
      this.focusOnTable('primaryWeaponsCols');
      this.isLoading = false;
    });
  }

  getAllImageTypes() {
    this.isLoading = true;
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<ImageType>(this.lookupSvc.imageTypesUrl).subscribe((imageTypes: ImageType[]) => {
      this.imageTypeCols = ImageType.ImageTypeColumnData(imageTypes);
      this.imageTypeRows = imageTypes;
      this.focusOnTable('imageTypeCols');
      this.isLoading = false;
    });
  }

  getBatchLogs() {
    this.isLoading = true; // show loading animation
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData(this.lookupSvc.getBatchLogUrl).subscribe((batches: BatchLog[]) => {
      this.batchLogCols = BatchLog.BatchLogColumnData(this.isAdmin);
      this.batchLogRows = batches;
      this.focusOnTable('batchLogCols');
      this.isLoading = false; // hide loading animation
    }, () => {
        this.isLoading = false; // hide loading animation
        this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Failure', 'Could not load batch logs', StarbaseNotificationTypes.Error));
      });
  }

  getAllWeapons() {
    this.isLoading = true;
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<Weapon>(this.lookupSvc.getWeaponsUrl).subscribe((w: Weapon[]) => {
      Weapon.setupWeaponCollection(w);
      this.lookupSvc.getAllRequisiteData<PrimaryWeapon>(this.lookupSvc.getPrimaryWeaponsUrl).subscribe(p => {
        this.weaponsCols = Weapon.WeaponColumnData(p, this.isAdmin); // get weapons columns'
        this.weaponsRows = w; // get weapons data
        if (this.newEntityMode === true) { // if adding a new row from new entity mode
          this.newEntityBackup.editMode = true; // switch original row to editMode is true
          this.weaponsCols.forEach(col => {
            if (col.name === 'primaryWeapon') { // find the correct data from the column definition's dropdownData, and assign it to the correct property of the original row
              this.newEntityBackup.primaryWeapon = col.dropdownData[col.dropdownData.length - 1]; // setting up original weapon row to be added back to weaponsRows
            }
          });
          if (this.newEntityBackup.uid !== 0) { // if the original row was already added
            this.findDuplicateRows(this.weaponsRows, this.newEntityBackup.uid); // get rid of the duplicate row, add the original row back to the weaponsRows array
          } else { // if the original row is also a new weapon row
            this.newEntityMode = false; // close new entity mode table, and then reopen the weapons table with refreshed data
            this.weaponsRows.unshift(this.newEntityBackup); // add original row back to weaponsRows
          }
        }
        this.isLoading = false;
      });
      this.focusOnTable('weaponsCols'); // finally, focus on the table
    });
  }

  getRanks() {
    this.isLoading = true;
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<Rank>(this.lookupSvc.getRanksUrl).subscribe((ranks: Rank[]) => {
      Rank.setupRankCollection(ranks);
      this.lookupSvc.getAllRequisiteData<RankCategory>(this.lookupSvc.getRankCatsUrl).subscribe(rc => {
        this.ranksCols = Rank.RankColumnData(rc, this.isAdmin);
        this.rankCategories = ranks;
        this.ranksRows = ranks;
        if (this.newEntityMode === true) {
          this.newEntityBackup.editMode = true;
          this.ranksCols.forEach(col => {
            if (col.name === 'rankCategoryName') {
              this.newEntityBackup.rankCategoryName = col.dropdownData[col.dropdownData.length - 1];
            }
          });
          if (this.newEntityBackup.uid !== 0) {
            this.findDuplicateRows(this.ranksRows, this.newEntityBackup.uid);
          } else {
            this.ranksRows.unshift(this.newEntityBackup);
            this.newEntityMode = false;
          }
        }
        this.focusOnTable('ranksCols');
        this.isLoading = false;
      });
    });
  }

  getRankCategories() {
    this.isLoading = true;
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<RankCategory>(this.lookupSvc.getRankCatsUrl).subscribe((ranks: RankCategory[]) => {
      this.rankCategoriesRows = ranks;
      this.rankCategoriesCols = RankCategory.RankCategoryColumnData(this.isAdmin);
      this.focusOnTable('rankCategoriesCols');
      this.isLoading = false;
    });
  }

  getSourceData() {
    this.isLoading = true;
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<LUSource>(this.lookupSvc.getLUSourcesUrl).subscribe(l => {
      this.sourceData = l;
      this.sourceCols = LUSource.LUSourceColumnData(this.isAdmin);
      this.focusOnTable('sourceCols');
      this.isLoading = false;
    });
  }

  focusOnTable(str) {
    setTimeout(() => {
      this.tableEditor._results.forEach(r => {
        r.nativeElement.classList.forEach(c => {
          if (c === str) {
            r.nativeElement.scrollIntoView({alignToTop: false, behavior: 'smooth', block: 'center', inline: 'nearest'});
            setTimeout(() => {
              r.nativeElement.focus();
            }, 250);
          }
        });
      });
    }, 100);
  }

  getLUarmy() {
    this.isLoading = true;
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData(this.lookupSvc.getLUArmiesUrl).subscribe((LUArmies: LUArmy[]) => {
      this.LUarmyCols = LUArmy.LUArmyColumnData(this.isAdmin);
      this.LUarmyRows = LUArmies;
      this.LUArmyData = LUArmies;
      this.focusOnTable('LUarmyCols');
      this.isLoading = false;
    });
  }

  getLUQmSourceReferences() {
    this.isLoading = true;
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData(this.lookupSvc.getLUQmSourceReferenceUrl).subscribe((LU_QM_SourceReferences: LU_QM_SourceReference[]) => {
      this.LuQmSourceReferenceCols = LU_QM_SourceReference.LuQMSourceReferenceColumnData(this.isAdmin);
      this.LuQmSourceReferenceRows = LU_QM_SourceReferences;
      this.LuQmSourceReferenceData = LU_QM_SourceReferences;
      this.focusOnTable('LUQmSourceReferenceCols');
      this.isLoading = false;
    });
  }

  getLUQmSpecificationCategory() {
   this.isLoading = true;
     this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<LU_QM_SpecificationCategory>(this.lookupSvc.getLUSpecificationCategoryUrl).subscribe((LU_QM_SpecificationCategories: LU_QM_SpecificationCategory[]) => {
      this.LU_QM_SpecificationCategoryCols = LU_QM_SpecificationCategory.LU_QM_SpecificationCategoryColumnData(this.isAdmin);
      this.LU_QM_SpecificationCategoryRows = LU_QM_SpecificationCategories;
      this.LU_QM_SpecificationCategoryData = LU_QM_SpecificationCategories;
      this.focusOnTable('LU_QM_SpecificationCategoryCols');
      this.isLoading = false;
    });
  }

  getStates() {
    this.isLoading = true;
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<State>(this.lookupSvc.getStatesUrl).subscribe((states: State[]) => {
      this.statesRows = states;
      this.statesCols = State.StateColumnData(this.isAdmin);
      this.focusOnTable('statesCols');
      this.isLoading = false;
    });
  }

  getRegiments() {
    this.isLoading = true;
    this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<Regiment>(this.lookupSvc.getRegimentNosUrl).subscribe((regiments: Regiment[]) => {
      Regiment.setupCollection(regiments);
      this.lookupSvc.getAllRequisiteData<State>(this.lookupSvc.getStatesUrl).subscribe(() => {
        this.regimentCols = Regiment.RegimentColumnData(this.isAdmin);
        this.regimentRows = regiments;
        this.focusOnTable('regimentCols');
        this.isLoading = false;
      });
    });
  }

  getBranches() {
    this.isLoading = true;
    this.dataLoadSubscription =  this.lookupSvc.getAllRequisiteData<BranchOfService>(this.lookupSvc.getBranchesUrl).subscribe((branches: BranchOfService[]) => {
      this.branchRows = branches;
      this.branchCols = BranchOfService.BranchOfServiceColumnData(this.isAdmin);
      this.focusOnTable('branchCols');
      this.isLoading = false;
    });
  }

  removeTable(tableName: string) {
    console.log(tableName);
    if (this[tableName + 'EditMode'] === true) {
      this.enableLeavePageModal().subscribe(a => {
        if (a === true) {
          this[tableName] = [];
          this[tableName + 'EditMode'] = false;
        }
      });
    }
    if (this[tableName + 'EditMode'] === false) {
      this[tableName] = [];
    }
  }

  handleEdit(e, tableName) {
    this[tableName + 'EditMode'] = e;
    this.activeTables.push(tableName + 'EditMode');
    this.updateEditMode();
  }

  updateEditMode() {
    let b = false;
    this.activeTables.forEach(str => {
      if (this[str] === true) {
        b = true;
      }
    });
    return b;
  }

  unsavedChangesCheck(): Observable<boolean> {
    if (this.updateEditMode() === true) {
      return this.enableLeavePageModal();
    } else {
      return of (true);
    }
  }

  handleInvalidData() {
    console.log('ERROR');
    this.enableRowModificationFailure('Invalid Data');
  }

  handleCancelNewEntityEvent() {
    this.newEntityMode = false;
    this.newEntityRows = [];
  }

  handleDeleteBoundImageSet(e) {
    const modal = new StarbaseModalOptions('Confirm Deletion', 'This will remove the Bound Image Set, but will NOT delete the image records. All images belonging to this set will once again be displayed on the Gallery after the binding has been deleted.', [
      new StarbaseModalButton('Yes', () => {
        this.lookupSvc.deleteEntireBoundImageSet(e.name).subscribe(() => {
          this.entireBoundImageSetsNotifier.valueChanged(null); // tell the table-editor to remove the specified row
          this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Success', 'Bound Image Set deleted', StarbaseNotificationTypes.Success));
        }, () => {
            this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Failure', 'Unable to delete Bound Image Set', StarbaseNotificationTypes.Error));
          });
        this.modalSvc.closeModal('User Deleted Row');
      }),
      new StarbaseModalButton('No', () => {
        this.modalSvc.closeModal('User did not delete row');
      }),
    ], 3);
    modal.dismissable = true;
    this.modalSvc.postModal(modal);
  }

  handleDeleteRow(delFnName: string, row: IRowModel, getFnName: string, type: string) {
    this.isLoading = true;
    this.enableDeleteRowModal().subscribe(b => {
      if (b === true) {
        if (row.uid !== 0) {
          this.lookupSvc[delFnName](row.uid).subscribe(() => {
            this[getFnName]();
            const notifierString = type + 'Notifier';
            this[notifierString].valueChanged(row.uid);
            this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Success!', 'Record successfully deleted', undefined, undefined, StarbaseNotificationSentiment.Success));
            this.isLoading = false;
          }, e => {
            console.log('Error found');
            if (e.code === 500) {
              this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Data deletion failure', 'Record is referenced elsewhere', undefined, undefined, StarbaseNotificationSentiment.Error));
            } else {
              this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Failure', 'Record deletion failed', undefined, undefined, StarbaseNotificationSentiment.Error));
            }
            this.isLoading = false;
          });
        }
      } else if (b === false) {
        this[getFnName]();
        this.isLoading = false;
      }
    });
  }


  //FIXME: OUTDATED REVIEW FOR REMOVAL
  /*
  handleDeleteRelatedSet(row: IRowModel): void {
    //TODO: Update to new model -> RelatedSetModel
    this.isLoading = true;
    this.enableDeleteRowModal(
      'Are you sure you want to delete this set of Related Images? The images in the set will remain, but will no longer be related to each other with the name ' + row['name'] + '.'
    ).subscribe(b => {
      if (b === true) {
        this.lookupSvc.deleteFullRelatedSet(row)
          .pipe(finalize(() => this.isLoading = false))
          .subscribe(
            () => {
              this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Success', 'Related Image Set deleted', undefined, undefined, StarbaseNotificationSentiment.Success));
              this.getRelatedImageData(); // refresh
            },
            e =>
              this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Failure', 'Could not delete the set', undefined, undefined, StarbaseNotificationSentiment.Error)));
      } else {
        this.getRelatedImageData();
        this.isLoading = false;
      }
    });
  }
  */

  handleModifySource(row: IRowModel) {
    this.isLoading = true;
    const s = new LUSource();
    s.source = row.source;
    s.uid = row.uid;
    s.createdByUser = row.createdByUser;
    s.createdDateTime = row.createdDateTime;
    s.homePageUrl = row.homePageUrl;
    s.logoPath = row.logoPath;
    if (row.uid === 0) {
      this.dataLoadSubscription = this.lookupSvc.postRequisiteData<LUSource>(this.lookupSvc.postLUSourceUrl, s).subscribe((() => {
        this.getSourceData();
        this.enableRowModifiedNotification('New Source Added');
        this.isLoading = false;
      }), () => {
          this.enableRowModificationFailure();
          this.isLoading = false;
        });
    } else {
      this.dataLoadSubscription = this.lookupSvc.putRequisiteData<LUSource>(this.lookupSvc.putLUSourceUrl, s.uid.toString(), s).subscribe((() => {
        this.enableRowModifiedNotification('Source Data Updated');
        this.isLoading = false;
      }), () => {
          this.enableRowModificationFailure();
          this.isLoading = false;
        });
    }
  }

  handleModifyCallNos(row: IRowModel) {
    this.isLoading = true;
    const s = new CallNumberModel();
    row = this.filterDropdownData(row, this.callNumberCols);
    s.callNumberL1 = row.callNumberL1 ? row.callNumberL1.trim() : '';
    s.callNumberL2 = row.callNumberL2 ? row.callNumberL2.trim() : '';
    s.callNumberL3 = row.callNumberL3 ? row.callNumberL3.trim() : '';
    s.callNumberL4 = row.callNumberL4 ? row.callNumberL4.trim() : '';
    s.createdByUser = row.createdByUser;
    s.createdDateTime = row.createdDateTime;
    s.description = row.description;
    s.lU_SourceUID = row.source.uid;
    s.uid = row.uid;
    if (!s.lU_SourceUID || !s.callNumberL1) { // input validation
      this.notificationSvc.postNotification(
        this.notificationSvc.notificationBuilder(
          'Invalid Call Number data',
          'A Source Call Number record must include at least a source and the first call # level.',
          StarbaseNotificationTypes.Error,
          7500
        )
      );
      this.isLoading = false;
      return;
    }
    if (row.uid === 0) { // create new record
      this.dataLoadSubscription = this.lookupSvc.postRequisiteData<CallNumberModel>(this.lookupSvc.postCallNumberUrl, s)
        .subscribe(() => {
          this.getCallNumbers();
          this.enableRowModifiedNotification('New Call Number Added');
          this.isLoading = false;
        },
        () => {
          this.enableRowModificationFailure();
          this.isLoading = false;
        });
    } else {
      this.dataLoadSubscription = this.lookupSvc.putRequisiteData<CallNumberModel>(this.lookupSvc.putCallNumberUrl, s.uid.toString(), s)
        .subscribe(
          () => {
            this.enableRowModifiedNotification('Call Number Updated');
            this.isLoading = false;
          },
          () => {
            this.enableRowModificationFailure();
            this.isLoading = false;
          }
        );
    }
  }

  handleModifyBranch(row: IRowModel) {
    this.isLoading = true;
    const branch = new BranchOfService();
    branch.createdByUser = row.createdByUser;
    branch.createdDateTime = row.createdDateTime;
    branch.branchName = row.branchName;
    branch.uid = row.uid;
    if (row.uid === 0) {
      this.dataLoadSubscription = this.lookupSvc.postRequisiteData<BranchOfService>(this.lookupSvc.postBranchUrl, branch).subscribe((() => {
        this.getBranches();
        this.enableRowModifiedNotification('New Branch Added');
        this.isLoading = false;
      }), () => {
          row.editMode = true;
          this.enableRowModificationFailure('Duplicate Branch');
          this.isLoading = false;
        });
      this.newEntityMode = false;
    } else if (row.uid !== 0) {
      this.dataLoadSubscription = this.lookupSvc.putRequisiteData<BranchOfService>(this.lookupSvc.putBranchUrl, branch.uid.toString(), branch).subscribe((() => {
        this.enableRowModifiedNotification('Branch Data Updated');
        this.isLoading = false;
      }), () => {
          row.editMode = true;
          this.enableRowModificationFailure('Duplicate Branch');
          this.isLoading = false;
        });
    }
  }

  handleModifyRegiment(row: IRowModel) {
    this.isLoading = true;
    const regiment = new Regiment();
    regiment.uid = row.uid;
    regiment.regimentNo = row.regimentNo;
    regiment.createdByUser = row.createdByUser;
    regiment.createdDateTime = row.createdDateTime;
    if (row.uid !== 0) {
      this.dataLoadSubscription = this.lookupSvc.putRequisiteData(this.lookupSvc.putRegimentNoUrl, regiment.uid.toString(), regiment).subscribe((() => {
        this.enableRowModifiedNotification('Regiment Data Updated');
        this.isLoading = false;
      }), () => {
          this.enableRowModificationFailure();
          this.isLoading = false;
        });
    } else if (row.uid === 0) {
      this.dataLoadSubscription = this.lookupSvc.postRequisiteData<Regiment>(this.lookupSvc.postRegimentNoUrl, regiment).subscribe((() => {
        this.getRegiments();
        this.enableRowModifiedNotification('New Regiment Added');
        this.isLoading = false;
      }), () => {
          this.enableRowModificationFailure();
          this.isLoading = false;
        });
      this.newEntityMode = false;
    }
  }

  handleModifyArmy(row: any) {
    this.isLoading = true;
    if (row.uid !== 0) {
      row.armyId = row.army.uid;
      row.armyName = row.army.armyName;
      this.dataLoadSubscription = this.lookupSvc.putRequisiteData<Army>(this.lookupSvc.putArmyUrl, row.uid.toString(), row).subscribe((() => {
        this.enableRowModifiedNotification('Regional Army Data Updated');
        this.isLoading = false;
      }), () => {
          this.enableRowModificationFailure();
          this.isLoading = false;
        });
    } else if (row.uid === 0) {
      this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData<LUArmy>(this.lookupSvc.getLUArmiesUrl).subscribe(data => {
        data.forEach(a => {
          if (a.armyName === row.armyName) {
            const r = new Army();
            r.armyName = a.armyName;
            r.regionalName = row.regionalName;
            r.armyId = a.uid;
            r.uid = 0;
            this.lookupSvc.postRequisiteData<Army>(this.lookupSvc.postArmyUrl, r).subscribe((() => {
              this.getArmies();
              this.enableRowModifiedNotification('New Regional Army Added');
              this.isLoading = false;
            }), () => {
                this.enableRowModificationFailure();
                this.isLoading = false;
              });
          }
        });
      });
    }
    this.newEntityMode = false;
  }

  handleModifyRankCategory(row: IRowModel) {
    this.isLoading = true;
    const r = new RankCategory();
    r.createdByUser = row.createdByUser;
    r.createdDateTime = row.createdDateTime;
    r.rankCategory = row.rankCategory;
    r.uid = row.uid;
    if (row.uid !== 0) {
      this.dataLoadSubscription = this.lookupSvc.putRequisiteData<RankCategory>(this.lookupSvc.putRankCatUrl, r.uid.toString(), r).subscribe((() => {
        this.enableRowModifiedNotification('Rank Category Data Updated');
        this.isLoading = false;
      }), () => {
          this.enableRowModificationFailure();
          this.isLoading = false;
        });
    } else if (row.uid === 0) {
      this.dataLoadSubscription = this.lookupSvc.postRequisiteData<RankCategory>(this.lookupSvc.postRankCatUrl, r).subscribe((() => {
        if (this.newEntityMode) {
          this.ranksRows = [];
          this.getRanks();
        } else {
          this.newEntityMode = false;
          this.getRankCategories();
        }
        this.enableRowModifiedNotification('New Rank Category Added');
        this.isLoading = false;
      }), () => {
          row.editMode = true;
          this.enableRowModificationFailure('Duplicate Rank Category');
          this.isLoading = false;
        });
    }
  }

  handleModifyWeaponCategory(row: IRowModel) {
    this.isLoading = true;
    const p = new PrimaryWeapon();
    p.uid = row.uid;
    p.createdByUser = row.createdByUser;
    p.createdDateTime = row.createdDateTime;
    p.editable = row.editable;
    p.weapon_Category = row.weapon_Category;
    if (row.uid !== 0) { // if modifying an existing row
      this.dataLoadSubscription = this.lookupSvc.putRequisiteData<PrimaryWeapon>(this.lookupSvc.putPrimaryWeaponUrl, p.uid.toString(), p).subscribe((() => {
        this.enableRowModifiedNotification('Weapon Category Data Updated');
        this.isLoading = false;
      }), () => {
          this.enableRowModificationFailure('Duplicate Weapon Category');
          this.isLoading = false;
        });
    } else if (row.uid === 0) { // if saving a new row
      this.dataLoadSubscription = this.lookupSvc.postRequisiteData(this.lookupSvc.postPrimaryWeaponUrl, p).subscribe((() => {
        if (this.newEntityMode === true) { // if save a new row from new entity mode, refresh data, handle the original row from the getAllWeapons function
          this.getAllWeapons();
        } else {
          this.newEntityMode = false;
          this.getPrimaryWeapons();
        }
        this.enableRowModifiedNotification('New Weapon Category Added');
        this.isLoading = false;
      }), () => {
          this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Error', 'Duplicate Weapon Category', 3));
          this.isLoading = false;
        });
    }
  }

  findDuplicateRows(arr, uid: number) {
    let i = 0;
    arr.find(r => {
      if (r.uid === uid) {
        arr[i] = this.newEntityBackup;
      } else {
        i++;
      }
    });
    this.newEntityMode = false;
  }

  handleModifyImageType(row: IRowModel) {
    this.isLoading = true;
    if (row.uid !== 0) {
      row.uid = row.typeOfImage.uid;
      row.typeOfImage = row.typeOfImage.imageType;
      this.lookupSvc.putRequisiteData(this.lookupSvc.putImageTypeUrl + '/' + row.uid, row.uid.toString(), row).subscribe((() => {
        this.enableRowModifiedNotification('Image Type Data Updated');
        this.isLoading = false;
      }), () => {
          this.enableRowModificationFailure();
          this.isLoading = false;
        });
    } else if (row.uid === 0 ) {
      row.uid = row.typeOfImage.uid;
      row.typeOfImage = row.typeOfImage.imageType;
      this.lookupSvc.postRequisiteData(this.lookupSvc.postImageTypeUrl, row).subscribe((() => {
        this.enableRowModifiedNotification('New Image Type Added');
        this.isLoading = false;
      }), () => {
          this.enableRowModificationFailure();
          this.isLoading = false;
        });
    }
    this.newEntityMode = false;
  }

  handleModifyBatchLog(row: IRowModel) {
    this.isLoading = true;
    this.lookupSvc.renameBatchLogSet(row.batchName, row.uid).subscribe(() => {
      this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Success', 'Upload Log name changed', StarbaseNotificationTypes.Success));
      this.isLoading = false;
    }, () => {
        this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Error', 'Upload Log name could not be changed', StarbaseNotificationTypes.Error));
        this.isLoading = false;
      });
  }

  handleDeleteBatchLog(e) {
    if (e.numberOfFilesSuccessfullyUploaded === 0) {
      this.enableDeleteRowModal('Are you sure you want to delete this Upload Batch record?').subscribe(a => {
        if (a === true) {
          this.lookupSvc.deleteData(this.lookupSvc.deleteBatchLogUrl, e.uid.toString()).subscribe(() => {
            this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Deleted successfully', 'Batch Upload Log Deleted', StarbaseNotificationTypes.Success));
            // this.modalSvc.closeModal('User pressed delete.');
            this.batchLogRowsNotifier.valueChanged(e);
          });
        } else {
          this.modalSvc.closeModal('User cancelled deletion');
          this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Deletion canceled', 'User cancelled deletion', StarbaseNotificationTypes.Info));
        }
      });
    } else {
      const yesBtn = new StarbaseModalButton('Yes, delete forever', () => {
        this.dataLoadSubscription = this.lookupSvc.deleteData(this.lookupSvc.deleteBatchLogUrl, e.uid.toString()).subscribe(() => {
            this.deleteModal.working = true;
            yesBtn.name = 'Please wait...';
            this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Deleted successfully', 'Batch Upload Log Deleted', StarbaseNotificationTypes.Success));
            this.modalSvc.closeModal('User pressed delete.');
            this.batchLogRowsNotifier.valueChanged(e);
          }, () => {
              this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Error', 'Deletion failed', StarbaseNotificationTypes.Error));
              this.deleteModal.working = false;
              yesBtn.name = 'Yes, delete forever';
            });
      });
      const noBtn = new StarbaseModalButton('Cancel', () => {
        this.modalSvc.closeModal('User pressed cancel');
      });
      this.deleteModal = new StarbaseModalOptions('Confirm Deletion', '', [yesBtn, noBtn], StarbaseModalTypes.Error, this.deleteMultipleUploadLogsModal);
      this.modalSvc.postModal(this.deleteModal);
    }
  }

  handleModifyWeapon(row: IRowModel) {
    this.isLoading = true;
    row = this.filterDropdownData(row, this.weaponsCols);
    const w = new Weapon();
    row['primaryWeapon'] = row.weapon_Category;
    w.primaryWeaponUID = row.primaryWeapon.uid;
    w.uid = row.uid;
    w.weapon = row.secondaryWeapon;
    if (w.uid !== 0) {
      w.createdByUser = row.createdByUser;
      w.createdDateTime = row.createdDateTime;
      this.dataLoadSubscription = this.lookupSvc.putRequisiteData<Weapon>(this.lookupSvc.putWeaponUrl, w.uid.toString(), w).subscribe((() => {
        this.enableRowModifiedNotification('Weapon Data Updated');
        row.weapon_Category = row.primaryWeapon.weapon_Category;
        this.isLoading = false;
      }), () => {
          this.enableRowModificationFailure('Duplicate Weapon');
          this.isLoading = false;
        });
    } else if (w.uid === 0) {
      this.lookupSvc.postRequisiteData<Weapon>(this.lookupSvc.postWeaponUrl, w).subscribe((() => {
        this.getAllWeapons();
        this.enableRowModifiedNotification('New Weapon Added');
        this.isLoading = false;
      }), () => {
          this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Error', 'Duplicate Weapon', 3));
          this.isLoading = false;
        });
    }
    this.newEntityMode = false;
  }

  handleModifyState(row: IRowModel) {
    this.isLoading = true;
    const s = new State();
    typeof(row.state_Name) === 'string' ? s.state_Name = row.state_Name : s.state_Name = row.state.state_Name;
    typeof(row.abbreviation) === 'string' ? s.abbreviation = row.abbreviation : s.state_Name = row.state.abbreviation;
    s.uid = row.uid;
    s.createdByUser = row.createdByUser;
    s.createdDateTime = row.createdDateTime;
    if (row.uid !== 0) {
      this.dataLoadSubscription = this.lookupSvc.putRequisiteData(this.lookupSvc.putStateUrl, s.uid.toString(), s).subscribe((() => {
        this.enableRowModifiedNotification('State Data Updated');
        this.isLoading = false;
      }), () => {
          this.enableRowModificationFailure('Duplicate State');
          this.isLoading = false;
        });
    } else if (row.uid === 0) {
      this.dataLoadSubscription = this.lookupSvc.postRequisiteData<State>(this.lookupSvc.postStateUrl, s).subscribe((() => {
        this.getStates();
        this.enableRowModifiedNotification('New State Added');
        this.isLoading = false;
      }), () => {
          this.enableRowModificationFailure('Duplicate State');
          this.isLoading = false;
        });
    }
    this.newEntityMode = false;
  }

  filterDropdownData(row: IRowModel, columns: IColumnModel[], key?: string): any {
    columns.forEach(col => {
      if (col.dataType === 'dropdown') {
        col.dropdownData.forEach(obj => { //
          if (obj[col.dropdownProperty] === row[col.dropdownProperty]) {
            // if the row should be modified at a location other than row[col.dropdownProperty], should include a key when calling fn
            row[key ? col[key] : col.dropdownProperty] = obj;
          }
        });
      }
    });
    // return the modified row, which is the same as the original row, but with an object from dropdown data at row[col.dropdownProperty] instead of a string
    return row;
  }

  handleModifyRank(row: IRowModel) {
    this.isLoading = true;
    row = this.filterDropdownData(row, this.ranksCols);
    const r = new Rank();
    row.rankCategory = row.rankCategoryName;
    r.rankName = row.rankName;
    r.uid = row.uid;
    r.rankCategoryId = row.rankCategory.uid;
    if (row.uid !== 0) {
      r.rankCategory = row.rankCategoryName;
      r.createdByUser = row.createdByUser;
      r.createdDateTime = row.createdDateTime;
      r.rankCategoryName = r.rankCategory.rankCategory;
      this.dataLoadSubscription = this.lookupSvc.putRequisiteData<Rank>(this.lookupSvc.putRankUrl, r.uid.toString(), r).subscribe((() => {
        this.enableRowModifiedNotification('Rank Data Updated');
        this.isLoading = false;
      }), () => {
          row.editMode = true;
          this.enableRowModificationFailure('Duplicate Rank');
          this.isLoading = false;
        });
    } else if (r.uid === 0) {
      this.dataLoadSubscription = this.lookupSvc.postRequisiteData<Rank>(this.lookupSvc.postRankUrl, r).subscribe((() => {
        this.getRanks();
        this.enableRowModifiedNotification('New Rank Added');
        this.isLoading = false;
      }), () => {
          row.editMode = true;
          this.enableRowModificationFailure('Duplicate Rank');
          this.isLoading = false;
        });
    }
    row.rankCategoryName = row.rankCategoryName.rankCategory;
    this.newEntityMode = false;
  }

  handleModifyLUArmy(row: IRowModel) {
    this.isLoading = true;
    const a = new LUArmy();
    a.uid = row.uid;
    a.createdDateTime = row.createdDateTime;
    a.createdByUser = row.createdByUser;
    a.armyName = row.armyName;
    if (row.uid !== 0) {
      this.lookupSvc.putRequisiteData(this.lookupSvc.putLUArmyUrl, a.uid.toString(), a).subscribe((() => {
        this.getLUarmy();
        this.enableRowModifiedNotification('Army Data Updated');
        this.isLoading = false;
      }), () => {
          this.enableRowModificationFailure('Duplicate Army');
          row.editMode = true;
          this.isLoading = false;
        });
    } else if (row.uid === 0) {
      this.dataLoadSubscription = this.lookupSvc.postRequisiteData(this.lookupSvc.postLUArmyUrl, a).subscribe((() => {
        this.getLUarmy();
        this.enableRowModifiedNotification('New Army Added');
        this.isLoading = false;
      }), () => {
          this.enableRowModificationFailure('Duplicate Army');
          row.editMode = true;
          this.isLoading = false;
        });
    }
  }

  handleModifyLuQmSourceReference(row: IRowModel) {
    this.isLoading = true;
  const a = new LU_QM_SourceReference();
    a.uid = row.uid;
    a.createdDateTime = row.createdDateTime;
    a.createdByUser = row.createdByUser;
    a.sourceReference = row.sourceReference;

  if (row.uid !== 0) {
    this.lookupSvc.putRequisiteData(this.lookupSvc.putLUQmSourceReferenceUrl, a.uid.toString(), a).subscribe((() => {
      this.getLUQmSourceReferences();
      this.enableRowModifiedNotification('QM Source Reference Updated');
      this.isLoading = false;
    }), () => {
          this.enableRowModificationFailure('Duplicate QM Source Reference');
          row.editMode = true;
          this.isLoading = false;
        });
    } else if (row.uid === 0) {
    this.dataLoadSubscription = this.lookupSvc.postRequisiteData(this.lookupSvc.postLUQmSourceReferenceUrl, a).subscribe((() => {
      this.getLUQmSourceReferences();
      this.enableRowModifiedNotification('New QM Source Reference Added');
      this.isLoading = false;
    }), () => {
      this.enableRowModificationFailure('Duplicate QM Source Reference');
      row.editMode = true;
      this.isLoading = false;
        });
    }
  }

  handleModifyLU_QM_SpecificationCategory(row: IRowModel) {
    this.isLoading = true;
    const a = new LU_QM_SpecificationCategory();
    a.uid = row.uid;
    a.createdDateTime = row.createdDateTime;
    a.createdByUser = row.createdByUser;
    a.specificationCategory = row.specificationCategory;

    if (row.uid !== 0) {
      this.lookupSvc.putRequisiteData<LU_QM_SpecificationCategory>(this.lookupSvc.putLUSpecificationCategoryUrl, a.uid.toString(), a).subscribe((() => {
        this.getLUQmSpecificationCategory();
        this.enableRowModifiedNotification('QM Specification Category Updated');
        this.isLoading = false;
      }), () => {
        this.enableRowModificationFailure('Duplicate QM Specification Category');
        row.editMode = true;
        this.isLoading = false;
      });
    } else if (row.uid === 0) {
      this.dataLoadSubscription = this.lookupSvc.postRequisiteData<LU_QM_SpecificationCategory>(this.lookupSvc.postLUSpecificationCategoryUrl, a).subscribe((() => {
        this.getLUQmSpecificationCategory();
        this.enableRowModifiedNotification('New QM Specification Category Added');
        this.isLoading = false;
      }), () => {
        this.enableRowModificationFailure('Duplicate QM Specification Category');
        row.editMode = true;
        this.isLoading = false;
      });
    }
  }

  handleNewEntity(obj: {key: string; row: IRowModel}) { // user has entered new entity mode
    this.newEntityBackup = obj.row;
    switch (obj.key) { // Enable new entity mode table editor, add corresponding rows for the new entity type
      case 'branchName':
      case 'branch':
        this.newEntityColumnData =  [
          new ColumnModel('UID', 'uid', 'UID', false, 'number', false, true, 10, false),
          new ColumnModel('Branch', 'branchName', 'branchName', true, 'string', false, true, 10, false)];
        this.newEntityModeTitle = 'Add a New Branch';
        this.newEntityModeType = 'branch';
      break;
      case 'state_Name':
      case 'state':
        this.newEntityColumnData = [
          new ColumnModel('UID', 'uid', 'uid', false, 'number', false, true, 10, false),
          new ColumnModel('State', 'state_Name', 'state_Name', true, 'string', false, true, 20, false, this.statesCols, 'state_Name'),
          new ColumnModel('Abbreviation', 'abbreviation', 'abbreviation', true, 'string', false, true, 100, false)];
        this.newEntityModeTitle = 'Add a New State';
        this.newEntityModeType = 'state';
      break;
      case 'regimentDisplay':
      case 'regimentNo':
           this.newEntityColumnData = [
             new ColumnModel('UID', 'uid', 'UID', false, 'number', false, true, 10, false),
             new ColumnModel('Regiment', 'regimentNo', 'RegimentNo', true, 'number', false, true, 10, false),
             new ColumnModel('State', 'state', 'state', true, 'dropdown', false, true, 20, false, this.stateData, 'state_Name')];
          this.newEntityModeTitle = 'Add a New Regiment';
          this.newEntityModeType = 'regiment';
      break;
      case 'primaryWeapon':
      case 'weapon_Category':
      this.newEntityColumnData = [
        new ColumnModel('UID', 'uid', 'uid', false, 'number', false, true, 10, false),
        new ColumnModel('Weapon Category', 'weapon_Category', 'weapon_Category', true, 'string', false, false, 30, false)];
      this.newEntityModeTitle = 'Add a New Weapon Type';
      this.newEntityModeType = 'primaryWeapon';
      break;
    case 'sourceReference':
      this.newEntityColumnData = [
      new ColumnModel('UID', 'uid', 'uid', false, 'number', false, true, 10, false),
      new ColumnModel('Source Reference', 'sourceReference', 'sourceReference', true, 'string', false, true, 255, true)];
      this.newEntityModeTitle = 'Add new QM Source Reference';
      this.newEntityModeType = 'sourceReference';
      break;

      case 'armyName':
        this.newEntityColumnData = [
          new ColumnModel('UID', 'uid', 'uid', false, 'number', false, true, 10, false),
          new ColumnModel('Army Name', 'armyName', 'armyName', true, 'string', false, true, 100, true)];
        this.newEntityModeTitle = 'Add a New Army';
        this.newEntityModeType = 'army';
      break;
      case 'rankCategoryName':
      case 'rankCategory':
      this.newEntityColumnData = [
        new ColumnModel('UID', 'uid', 'uid', false, 'number', false, true, 10, false),
        new ColumnModel('Rank Category', 'rankCategory', 'rankCategory', true, 'string', false, true, 100, true)];
      this.newEntityModeTitle = 'Add a New Rank Category';
      this.newEntityModeType = 'rankCategory';
      break;
    }
    this.newEntityMode = true;
    const row = new RowModel();
    row.uid = 0;
    row.editMode = true;
    this.newEntityRows = [row]; // Add a single empty row to the new entity mode table
  }

  handleModifyNewEntity(row: IRowModel) { // User has saved new entity i.e. a new rank category or weapon category, call corresponding function to save that data to the server
    switch (this.newEntityModeType) {
      case 'primaryWeapon':
    this.handleModifyWeaponCategory(row);
      break;
      case 'rankCategory':
    this.handleModifyRankCategory(row);
    break;
    case 'sourceReference':
    this.handleModifyLuQmSourceReference(row);
    break;
    case 'specificationCategory':
      this.handleModifyLU_QM_SpecificationCategory(row);
    break;
    }
  }

  toggleNewEditorTables(name: string): void {
    const table = this.lookupTables.find(t => t.name === name);
    table.active = !table.active;
    this.focusOnTable(name);
  }

  openLUOptions() {
    const OkBtn = new StarbaseModalButton(
      'Okay',
      () => {
        this.ngOnInit();
        this.modalSvc.closeModal('Closed LU options modal.');
      }
    );
    this.modalSvc.postModal(
      new StarbaseModalOptions(
        '"New" Starbase Table Editor options',
        undefined,
        [OkBtn],
        StarbaseModalTypes.Info,
        this.luOptionsModal
      )
    );
  }

  renameBoundSet(set: BoundImageSet, table) {
    table.loader = this.lookupSvc.renameBoundImageSet(this.currentBoundSetName, set.name).subscribe(
      () => {
        set.selected = false;
        this.currentBoundSetName = undefined;
        table.successfulEditCallback(set, null, table.getColloquialValue(set) + ' has been modified.');
        table.dataSvc.triggerRefresh(undefined, true);
      },
      (e) => table.saveErrorHandler(e)
    );
  }

  unbindBoundSet(e, table) {
    const modal = new StarbaseModalOptions('Confirm Unbinding', 'This will remove the Bound Image Set, but will NOT delete the image records. All images belonging to this set will once again be displayed on the Gallery after the binding has been deleted.', [
      new StarbaseModalButton('Yes', () => {
        this.lookupSvc.deleteEntireBoundImageSet(e.name).subscribe(() => {
          table.successfulDeletionCallback();
          table.dataSvc.triggerRefresh(undefined, true);
          table.loadData();
        // eslint-disable-next-line @typescript-eslint/no-shadow
        }, (e) => {
          table.saveErrorHandler(e);
        });
        this.modalSvc.closeModal('User Deleted Row');
      }),
      new StarbaseModalButton('No', () => {
        this.modalSvc.closeModal('User did not delete row');
      }),
    ], 3);
    modal.dismissable = true;
    this.modalSvc.postModal(modal);
  }

  renameRelatedSet(set: RelatedSetModel, table) {
    console.log(set)
    console.log(table)
    //TODO: Update to new model -> RelatedSetModel
    table.loader = this.lookupSvc.saveModifiedRecordSetToServer(set).subscribe(
      () => {
        set.selected = false;
        this.currentRelatedSetName = undefined;
        table.successfulEditCallback(set, null, table.getColloquialValue(set) + ' has been modified.');
        table.dataSvc.triggerRefresh(undefined, true);
      },
      (e) => table.saveErrorHandler(e)
    );
  }

  unrelateRelatedSet(e ,table): void {
    //TODO: Update to new model -> RelatedSetModel
    const modal = new StarbaseModalOptions('Confirm Disassociation', 'This will remove the Related Image Set, but will NOT delete the image records all images will simply no longer be related in this set.', [
      new StarbaseModalButton('Yes', () => {
        this.lookupSvc.deleteFullRelatedSet(e).subscribe(() => {
          table.successfulDeletionCallback();
          table.dataSvc.triggerRefresh(undefined, true);
          table.loadData();
        // eslint-disable-next-line @typescript-eslint/no-shadow
        }, (e) => {
          table.saveErrorHandler(e);
        });
        this.modalSvc.closeModal('User Deleted Row');
      }),
      new StarbaseModalButton('No', () => {
        this.modalSvc.closeModal('User did not delete row');
      }),
    ], 3);
    modal.dismissable = true;
    this.modalSvc.postModal(modal);
  }

  public save(data, row, setNameHolder): void {
    if (!row.allowEdit) {
      return; 
    }

    row.setFocusOnce = false;
    if (!row.editRow) { // start edit mode
      row.editRow = true;
      data.selected = true;
      row.rowData.selected = true;
      const temp = this[setNameHolder];
      this[setNameHolder] = data.name;
      row.selectedEmitter.emit(temp);
      row.cd.markForCheck();
      row.setFocusToColumn(row.columnDefinitions.find(a => a.colloquial));
    } else {
      row.saveEmitter.emit(data);
      row.cd.markForCheck();
    }
  }

  public cancel(data, row): void {
    data.selected = false;
    row.editRow = false;
    row.setFocusOnce = false;
    row.cancelEmitter.emit(data);
    row.cd.markForCheck();
  }

  public deleteRow(data, row): void {
    row.deleteEmitter.emit(data);
    row.cd.markForCheck();
  }

  /**
   * Handles moving between edit mode for each row.
   *
   * @param editMode Sets the table's `editMode` to this value.
   * @param rowId Optional. Sets the `editRow` state of the `ITableRow` matching that Id. The value will match that of `onOff.`
   *  No effect if a row with that Id is not found. */
  changeEditMode(table, editMode: boolean, rowId, idPropName: string, currentSetName: string): void {
    table.editMode = editMode;
    if (rowId) {
      const row = table.rows.find(row => row.rowData[idPropName] === rowId);
      if (row) {
        row.rowData.selected = editMode;
        row.editRow = editMode;
      }
    }
    
    table.editModeEmitter.emit({ name: table.modelName, active: editMode });
  }

  openKeywordSynonymization(keyword: LU_Keyword) {
    this.keywordsSvc.showSynonymizationModal(keyword);
  }

} // END OF LookupTableWrapperComponent

export class Notifier {
  valueChanged: (data: any) => void = () => { };
}
